<app-dialog
  [primaryActionText]="
    'DOCUMENT.' + documentType + '.RENDERING.GENERATE_NEW_PDF'
      | uppercase
      | translate
  "
  [dialogType]="dialogType"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="generateNewPdfAction"
  [centerActions]="true"
  (onPrimaryAction)="onReRenderPdf.emit(document)"
>
  <div id="pdf-rerender-dialog">
    <app-icon class="pdf-not-found-icon" [icon]="pdfNotFoundIcon"> </app-icon>

    <h2 class="pdf-rendering-error-header">
      {{ 'LABEL.OOPS' | translate }}
    </h2>

    <p class="pdf-rendering-error-description">
      {{
        'DOCUMENT.' + documentType + '.RENDERING.HAVING_TROUBLE_FINDING'
          | uppercase
          | translate
      }}
    </p>

    <hr class="separator" />

    <p
      [innerHTML]="
        'DOCUMENT.' + documentType + '.RENDERING.FIND_ORIGINAL_PDF'
          | uppercase
          | translate: { docNumber: documentNumber }
          | safe: 'html'
      "
      class="pdf-rendering-error-prompt"
    ></p>
  </div>
</app-dialog>
